import { ArrowLeft2, ArrowRight2, Calendar } from "iconsax-react";
import { formatDateCalendarNavMonth } from "../../utils/functions/formatters";
import React from "react";
import { useStore } from "../../store/useStore";
import DatePicker from "react-datepicker";

interface CalendarNavMonthPropsProps {
  date: Date,
  show?: boolean
}

const CalendarNavMonthProps: React.FC<CalendarNavMonthPropsProps> = ({
  date, 
  show = true
}) => {
  const setFilters = useStore((state) => state.infraction.infractionRankingList.setFilters);
  const filters = useStore((state) => state.infraction.infractionRankingList.filters);

  const handleChange = (e: any) => {
    setFilters({
      ...filters,
      reference_month: new Date(e).toISOString(),
    });
  };
  const handleDateClick = (e: any) => {
    e.preventDefault();
  };
  const handleCalendarNavigation = (direction: 'prev' | 'next') => {
    const filterDate = new Date(filters.reference_month);
    if (direction === 'prev') filterDate.setMonth(filterDate.getMonth() - 1);
    else filterDate.setMonth(filterDate.getMonth() + 1);
    filterDate.setDate(1);
    setFilters({ 
      ...filters, 
      reference_month: filterDate.toISOString() 
    });
  };

  return (
    <div className={`flex bg-white rounded-[13px] p-3 gap-2 ${show ? '' : 'hidden'}`}>
      <div className="flex gap-4 w-fit ml-auto justify-end py-2 cursor-pointer" onClick={() => handleCalendarNavigation('prev')}>
        <ArrowLeft2 size="24" color={'#7B809A'} />
      </div>
      <div className="flex gap-2 w-fit ml-auto justify-end px-3 py-2 text-lg text-[#7B809A] font-semibold cursor-pointer" onClick={handleDateClick}>
        <Calendar size="24" color={'#7B809A'} />
        <DatePicker 
          selected={filters.reference_month === '' ? new Date() : new Date(filters.reference_month)} 
          onChange={handleChange}
          locale="pt-BR"
          customInput={<div>{formatDateCalendarNavMonth(filters.reference_month === '' ? new Date() : new Date(filters.reference_month))}</div>} 
          showMonthYearPicker 
        />
      </div>
      <div className="flex gap-4 w-fit ml-auto justify-end py-2 cursor-pointer" onClick={() => handleCalendarNavigation('next')}>
        <ArrowRight2 size="24" color={'#7B809A'} />
      </div>
    </div>
  );
};

export default CalendarNavMonthProps;
